var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangleGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.33203C0 2.1229 1.79086 0.332031 4 0.332031H6.66666C8.8758 0.332031 10.6667 2.12289 10.6667 4.33203V6.9987C10.6667 9.20783 8.87581 10.9987 6.66667 10.9987H4C1.79086 10.9987 0 9.20784 0 6.9987V4.33203Z",
    fill: "#28AF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleGreen);
export default __webpack_public_path__ + "static/media/rectangleGreen.1d01fce63d346514c65947a8dfba9181.svg";
export { ForwardRef as ReactComponent };